import { memo } from 'react';
import { Link } from 'react-router-dom';
import ServiceStatus from '../../common/header/ServiceStatus';
import { getCSRFToken } from './CookieHelper';


export default memo(function GLOFASLogoutButton(props: { fullScreen?: boolean; }) {

    const logoutVisibilityClass = props.fullScreen ? 'd-block d-md-none' : 'd-none d-lg-block';

    const onClick = () => {
        fetch("/api/_allauth/browser/v1/auth/session", {
            method: 'delete', credentials: 'include',
            headers: {
                'X-CSRFToken': getCSRFToken(),
            }
        }).catch((err) => {
            console.error(err);
        }).finally(() => {
            window.location.href = '/';
        })
    }
    return (
        <div className="d-flex flex-row ms-auto gap-3">
            {!props.fullScreen && (
                <>
                    <div className="my-auto">
                        <ServiceStatus backgroundColour="none" />
                    </div>
                    <Link className='text-white text-nowrap' to={'/messages'}>
                        Messages
                    </Link>
                </>
            )}
            <Link className="text-nowrap text-white" to="/user">My Account</Link>
            <a className={`${logoutVisibilityClass} efas-account-menu text-nowrap text-white`} href="/" onClick={onClick}>Logout</a>
        </div>
    );
});